import { gql } from '@apollo/client';

import { BRAND_COLORS_FRAGMENT, BRAND_IMAGES_FRAGMENT } from './fragments';

export const BRAND_IMAGES_QUERY = gql`
  query BrandImagesQuery($id: String!) {
    brand(id: $id) {
      ...BrandImages
    }
  }
  ${BRAND_IMAGES_FRAGMENT}
`;

export const BRAND_COLORS_IMAGES_QUERY = gql`
  query BrandColorsImagesQuery($id: String!) {
    brand(id: $id) {
      ...BrandColors
      ...BrandImages
    }
  }
  ${BRAND_COLORS_FRAGMENT}
  ${BRAND_IMAGES_FRAGMENT}
`;
